export const isDomesticShippingUseCookie = () => {
  if (document && /ZIGZAGLOCALE=(\w+)~(\w+)~(\w+)/.test(document.cookie)) {
    const country = RegExp.$2;
    return country === 'KR' ? true : false;
  }
  return true;
};
